import React from "react";

type Props = {
  children: React.ReactNode;
  isLoading?: boolean;
  HanddleOnSubmit: () => void;
};

const FormFather = ({ children, isLoading, HanddleOnSubmit }: Props) => {
  const handleOnClickSubmit = (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault();
    HanddleOnSubmit();
  };

  return (
    <form
      className="ps-form--checkout"
      method="post"
      onSubmit={handleOnClickSubmit}>
      <div className="ps-form__billing-info">{children}</div>
      <div className="form-group text_Center___develop">
        <button
          type="submit"
          className={`ps-btn develop__buttons btn__develop__movil text-white ${
            isLoading
              ? "progress-bar progress-bar-striped progress-bar-animated bg-danger"
              : ""
          }`}
          disabled={isLoading}>
          {isLoading ? (
            <>
              <span
                className="spinner-border spinner-border-md"
                role="status"
                aria-hidden="true"></span>
              <span className="ml-4">Procesando ...</span>
            </>
          ) : (
            "Generar ticket de pago"
          )}
        </button>
      </div>
    </form>
  );
};

export default FormFather;
